// Thin-outline Cancel (X) icon matching the 20x20 / #111113 visual weight of the
// other MT toolbar icons. MUI's CloseOutlined rendered thicker/bolder than the
// custom outline icons, so this keeps the toolbar consistent. Uses the same
// stroke style as the shared CloseIcon (rounded caps).
const MTCancelIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 5L5 15M5 5L15 15"
        stroke="#111113"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default MTCancelIcon
